import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"lighthouse-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M6 21.9999C6 21.9999 8 14.9999 8 9.99985V3.00146H16V9.99985C16 14.9999 18 21.9999 18 21.9999H14L13 17.9999H11L10 21.9999H6Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 2V3.00161M8 3.00161V10C8 15 6 22 6 22H10L11 18H13L14 22H18C18 22 16 15 16 10V3.00161M8 3.00161H16M16 3.00161V2M17 6H7M18 14H6","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 9.99805H12.0039V10.002H12V9.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Lighthouse2 = Vue.extend<IconProps>({
  name: 'Lighthouse2Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'lighthouse-2',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Lighthouse2;
